import { ITributosSobreLucroResponse } from "../../requests/types";

export default class TributosSobreLucro {
  constructor(readonly response: ITributosSobreLucroResponse | undefined) {}
}
